import React from 'react'
import { useFlag } from '@openfeature/react-sdk'
import { ChevronsUpDownIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useSession } from '@/entities/session'

import {
	LogoCDSmallIcon,
	LogoPOSmallIcon,
	LogoWSSmallIcon,
} from '@/shared/components/logos'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'
import {
	SidebarHeader,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from '@/shared/components/ui/sidebar'

export const getProjectName = () =>
	window.location.hostname.split('.')[0].replace('-workspace', '')
const project = getProjectName()
const isDev = project.includes('dev-')

export default function AppSidebarHeader() {
	return (
		<SidebarHeader>
			<SidebarMenu>
				<SidebarMenuItem>
					<DropdownMenu>
						<DropdownMenuTrigger asChild>
							<SidebarMenuButton
								size='lg'
								className='rounded-lg data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground'
							>
								<div className='flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground'>
									<LogoPOSmallIcon className='size-4 text-primary-foreground' />
								</div>
								<div className='grid flex-1 text-left text-sm leading-tight'>
									<span className='truncate font-medium'>Pricing platform</span>
								</div>
								<ChevronsUpDownIcon className='ml-auto' />
							</SidebarMenuButton>
						</DropdownMenuTrigger>
						<DropdownMenuContent
							className='w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg'
							align='start'
							side='bottom'
							sideOffset={4}
						>
							<CompeteraApps />
						</DropdownMenuContent>
					</DropdownMenu>
				</SidebarMenuItem>
			</SidebarMenu>
		</SidebarHeader>
	)
}
function CompeteraApps() {
	const { user } = useSession()
	const { t } = useTranslation()

	return (
		<DropdownMenuGroup>
			<DropdownMenuLabel className='text-xs text-muted-foreground'>
				{t('switch_to', {
					defaultValue: 'Switch to',
				})}
			</DropdownMenuLabel>
			<AppWorkspace
				disabled={!user?.apps?.find((app) => app.name === 'workspace')?.enabled}
			/>
			<AppCompetitiveData
				disabled={
					!user?.apps?.find((app) => app.name === 'competitive_data')?.enabled
				}
			/>
		</DropdownMenuGroup>
	)
}

const AppCompetitiveData = ({ disabled }: { disabled: boolean }) => {
	const newCdFlag = useFlag('new_cd', false)

	return (
		<DropdownMenuItem
			disabled={disabled}
			className='pl-2 font-bold select-none'
			asChild
		>
			<a
				href={
					disabled
						? undefined
						: newCdFlag.value
							? `https://${project}-cd.competera.net`
							: `https://${project.replace('dev-', '')}${
									isDev ? '-cd2-stg' : '-dashboard'
								}.competera.net/accounts/keycloak/login/`
				}
				rel='noopener noreferrer'
			>
				<div className='flex size-8 items-center justify-center rounded-lg border-green-700 bg-green-500'>
					<LogoCDSmallIcon className='size-4' />
				</div>
				Competitive data
			</a>
		</DropdownMenuItem>
	)
}
const AppWorkspace = ({ disabled }: { disabled: boolean }) => (
	<DropdownMenuItem
		disabled={disabled}
		className='pl-2 font-bold select-none'
		asChild
	>
		<a
			href={disabled ? undefined : `https://${project}-workspace.competera.net`}
			rel='noopener noreferrer'
		>
			<div className='flex size-8 items-center justify-center rounded-lg border bg-gray-800'>
				<LogoWSSmallIcon className='size-4' />
			</div>
			Workspace
		</a>
	</DropdownMenuItem>
)
